export default {
  setSearchParam(state, payload) {
    state.searchParam = payload.searchParam;
    return state;
  },
  setStores(state, payload) {
    state.stores = payload.stores;
    return state;
  },
  setApi(state, payload) {
    state.mapsApiReady = payload.mapsApiReady;
    return state;
  },
  setLocation(state, payload) {
    state.location = payload.location;
    return state;
  },
  setSyncedInputValues(state, payload) {
    state.syncedInputValues = payload.syncedInputValues;
    return state;
  }
};
